// Hopper window (UI-3; M15.2.1). Five slots in a row over a hopper block entity,
// plus the player inventory — the same generic container machinery as the chest,
// so every mutation flows through transaction.clickSlot (PLR-1). Client-only (ENG-1).
import { arraySlots, type ArrayContainer } from '../../../sim/game/containers/array';
import { maxStackFn, playerRefs, playerRows } from './crafting';
import { openWindow, refRange, returnToInventory, type WindowConfig } from './container';
import type { Game } from '../../boot';

/** Open a hopper block entity's 5-slot window. */
export function openHopper(game: Game, hopper: ArrayContainer): () => void {
  const slots = arraySlots(hopper, maxStackFn(game.registries));
  const refs = refRange(slots, 0, hopper.items.length, undefined, 'hopper');
  const pr = playerRefs(game.playerState.inventory);
  const set = new Set<object>([slots]);

  const cfg: WindowConfig = {
    title: 'Hopper',
    layout: [refs, [null], ...playerRows(pr)],
    quickTargets: (ref) => (set.has(ref.slots) ? [...pr.storage, ...pr.hotbar] : refs),
    onClose: (cursor) => returnToInventory(game, [cursor]),
  };
  return openWindow(game, cfg);
}
